var path = '/app/pages/login/login.html';
var html = "<div class=step> <div class=intro> <a class=btn-play ng-click=$ctrl.submit()></a> <a ng-click=\"$ctrl.state.isCreditVisible = !$ctrl.state.isCreditVisible\" class=btn-inf></a> </div> <div class=credit ng-show=$ctrl.state.isCreditVisible class=ng-hide> <a ng-click=\"$ctrl.state.isCreditVisible = !$ctrl.state.isCreditVisible\" class=btn-close></a> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/login/login.html
// module id = 268
// module chunks = 0